import * as React from 'react';

export function useSocketListener<TPayload>(
  socket: any | undefined,
  eventName: string,
  handler: (payload: TPayload) => void,
  enabled: boolean = true
): void {
  const savedHandler = React.useRef(handler);
  React.useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  React.useEffect(() => {
    if (!enabled || !socket || !eventName) {
      return;
    }

    const wrapped = (payload: TPayload): void => {
      savedHandler.current(payload);
    };

    socket.on(eventName, wrapped);
    return (): void => {
      socket.off(eventName, wrapped);
    };
  }, [socket, eventName, enabled]);
}
